export default __webpack_public_path__ + "static/media/gamification-spin-privy.66d0f591.png";